// `Symbol.search` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.search
require('../internals/define-well-known-symbol')('search');